// @ts-check

import { CameraController, E_CAMERA_EVENT, MapView, Mappedin, MappedinCoordinate, MappedinMap, getVenue } from "@mappedin/mappedin-js";
import { useEffect, useRef, useState } from "react";
import { MapNormalViewLogic } from "../Logic/mapNormalViewLogic";
import { Logger } from "../Utils/logger";


/**
 * @typedef {import("../../../actions/LiveMap/liveMapPageTypes").MapZoomLevel} MapZoomLevel
 * 
 */


// @param {React.MutableRefObject<HTMLDivElement | null>} refCurrentMapNode


/**
 * @param {any | undefined} sData
 * @param {MapView | undefined} mapView
 * @param {import("./useHandleMapClick").MapNodeRef} refCurrentMapNode
 * 
 */
export default function useRenderFullStatus(sData, mapView, refCurrentMapNode) {


  /**
   * @type {React.MutableRefObject<null | ((x:any) => void)>}
   */
  let zoomHandler = useRef(null);

  /**
   * @type {React.MutableRefObject<number>}
   */
  let previousCameraZoomRef = useRef(0);

  /**
   * @type {React.MutableRefObject<string>}
   */
  let previousZoomLevelRef = useRef('');

  /**
   * @type {React.MutableRefObject<any>}
   */
  let sDataRef = useRef(null);

  /**
   * @type {React.MutableRefObject<MapView | undefined>}
   */
  let mapViewRef = useRef();



  useEffect(() => {

    // console.log('useRenderFullStatus ===> ', zoomHandler.current);

    if (!mapView) {
      return;
    }
    
    let venue = mapView.venue;
    if (!venue) {
      return;
    }
      
    ////////////////////////////////////////////////////////////////////
    // Save the sData to a ref so we can use it in the zoom handler.
    // 
    // If we pass the sData as is to the zoom handler, it will be the
    // value of sData at the time the zoom handler was created, not
    // the current value of sData.
    //
    sDataRef.current = sData;
    mapViewRef.current = mapView;
    

    // console.log('useRenderFullStatus ===> DO!', refCurrentMapNode);
    let zoomLevel = determineZoomLevel(mapView);
    processRenderFullStatus(sData, mapView, refCurrentMapNode, () => { }, zoomLevel);


    if (zoomHandler.current === null) {
      // console.log('XXXXXXXXXXXXXXX  ===> zoomHandler');
      // let cameraChangedHandler = createCameraChangedHandler(previousCameraZoomRef, previousZoomLevelRef, venue, mapView, refCurrentMapNode, sDataRef);
      let cameraChangedHandler = createCameraChangedHandler(previousCameraZoomRef, previousZoomLevelRef, mapViewRef, refCurrentMapNode, sDataRef);
      zoomHandler.current = cameraChangedHandler;
      mapView.Camera.on(E_CAMERA_EVENT.CHANGED, cameraChangedHandler);
    }
    
    return () => {
      // console.log(' ------------- DESTRUKTOR !!!!!!!!! ===> ');
      if (zoomHandler.current) {
        mapView.Camera.off(E_CAMERA_EVENT.CHANGED, zoomHandler.current);
        zoomHandler.current = null;
      }
    };


  }, [sData, mapView, refCurrentMapNode]);
  // }, [sData, venue, mapView, refCurrentMapNode]);


  return [

  ];
}




/**
 * @param {MapView | undefined} mapView
 */
function determineZoomLevel(mapView) {
  
  if (!mapView) {
    return "BIRDS_EYE";
  }
  
  
  const ZOOM_THRESHOLD_BIRDS_EYE = 7000;
  // const ZOOM_THRESHOLD_FULL_MAP = 1200;
  const ZOOM_THRESHOLD_FULL_MAP = 1700;
  const ZOOM_THRESHOLD_CLOSE_UP = 700;

  let cameraZoom = mapView.Camera.zoom;

  /** @type {MapZoomLevel} */
  let zoomLevel = "BIRDS_EYE";
  if (cameraZoom < ZOOM_THRESHOLD_BIRDS_EYE) {
    zoomLevel = "FULL_MAP";
  }
  if (cameraZoom < ZOOM_THRESHOLD_FULL_MAP) {
    zoomLevel = "CLOSE_UP";
  }
  
  return zoomLevel;
}


// * @param {Mappedin} venue
// * @param {MapView} mapView


/**
 * @param {import("react").MutableRefObject<number>} previousZoomRef
 * @param {import("react").MutableRefObject<string>} previousZoomLevelRef
 * @param {import("react").MutableRefObject<MapView | undefined>} mapViewRef
 * @param {import("./useHandleMapClick").MapNodeRef} refCurrentMapNode
 * @param {import("react").MutableRefObject<any>} sDataRef
 * 
 */
function createCameraChangedHandler(previousZoomRef, previousZoomLevelRef, mapViewRef, refCurrentMapNode, sDataRef) {

  /**
   * @param {{tilt: number; position: MappedinCoordinate; zoom: number; rotation: number; }} e
   */
  return (e) => {
    let previousZoom = previousZoomRef.current;
    if (e.zoom !== previousZoom) {
      
      // console.log('ZOOOOOOOOOM refCurrentMapNode ===> ', refCurrentMapNode);
      // console.log('ZOOOOOOOOOM refCurrentMapNode ===> ', e.zoom, previousZoomRef.current, mapView.Camera.zoom);
      
      
      let sData = sDataRef.current;
      let mapView = mapViewRef.current;
      let venue = mapView?.venue;
      
      if (!sData) {
        return;
      }
      
      if (!venue) {
        return;
      }
      
      if (!mapView) {
        return;
      }
      
      
      
      let zoomLevel = determineZoomLevel(mapView);
      previousZoomRef.current = e.zoom;
      // const ZOOM_THRESHOLD_BIRDS_EYE = 5000;
      // const ZOOM_THRESHOLD_FULL_MAP = 1200;
      // const ZOOM_THRESHOLD_CLOSE_UP = 700;
      
      // let cameraZoom = e.zoom;
      
      // /** @type {MapZoomLevel} */
      // let zoomLevel = "BIRDS_EYE";
      // if (cameraZoom < ZOOM_THRESHOLD_BIRDS_EYE) {
      //   zoomLevel = "FULL_MAP";
      // }
      // if (cameraZoom < ZOOM_THRESHOLD_FULL_MAP) {
      //   zoomLevel = "CLOSE_UP";
      // }
      
      // console.log('CURRENT ZOOM LEVEL! ===> ', zoomLevel);
      
      let previousZoomLevel = previousZoomLevelRef.current;
      if (zoomLevel !== previousZoomLevel) {
        previousZoomLevelRef.current = zoomLevel;
        console.log('zoom level changed! ===> ', zoomLevel);
        // processRenderFullStatus(sData, venue, mapView, refCurrentMapNode, () => { }, zoomLevel);
        processRenderFullStatus(sData, mapView, refCurrentMapNode, () => { }, zoomLevel);
      }




      Logger.doLog('zoom changed! ===> ', e.zoom);
      // previousZoomRef.current = e.zoom;
      // processRenderFullStatus(sData, venue, mapView, null, () => { });
    }


  };

}


/**
 * @param {any | undefined} sData
 * @param {MapView} mapView
 * @param {import("./useHandleMapClick").MapNodeRef} refCurrentMapNode
 * @param {(venue: Mappedin, mapView: MapView) => void} recolorMap
 * @param {MapZoomLevel} zoomLevel
 */
function processRenderFullStatus(sData, mapView, refCurrentMapNode, recolorMap, zoomLevel) {
  MapNormalViewLogic.process(sData, mapView, refCurrentMapNode, recolorMap, zoomLevel);
}



